import React from 'react';
import { SxProps } from '@mui/system';

import { FeeValue } from '../../../store/modules/merchant/types';
import { BinaryToggle } from '../../../components/common/BinaryToggle';

export const FeeStyleToggle = ({
  value,
  onChange,
  disabled = false,
  sx,
}: {
  value: FeeValue['style'];
  onChange: (newValue: FeeValue['style']) => void;
  sx?: SxProps;
  disabled?: boolean;
}) => {
  return (
    <BinaryToggle
      value={value}
      onChange={onChange}
      options={[
        { value: 'PERCENTAGE', label: 'Percentage' },
        { value: 'FLAT', label: 'Dollar Amount' },
      ]}
      disabled={disabled}
      sx={sx}
    />
  );
};
